module.exports = __webpack_public_path__ + "img/xiao.f04befa8.png";